import FlexPage from './FlexPage';

export default FlexPage;
